import { createHistory, History } from 'history';
import { useRouterHistory } from 'react-router';

// adds app prefix to the basename, use object if access to browser history is required
export const browserHistory = useRouterHistory(createHistory)({
  basename: process.env.APP_PREFIX_PATH
}) as History;
